module.exports = __webpack_public_path__ + "media/out4_2.079946fc.mp4";